import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import LogoImg from "../../assets/svg/Logo";
import axios from "axios";
import { useParams } from "react-router-dom";

export default function Contact() {

  const getCurrentYear = () => {
    return new Date().getFullYear();
  }
 const backendUrl = process.env.REACT_APP_BACKEND_URL;
  console.log(backendUrl)
  const {name}=useParams()


  const [data, setData] = useState();
  useEffect(()=>{
    axios.get(`${backendUrl}/cms/name/${name}`)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.error("Error fetching school data:", err);
      });
  },[])
  return (
    <Wrapper>
      <div className="darkBg">
        <div className="container">
          <InnerWrapper className="flexSpaceCenter" style={{ padding: "30px 0" }}>
            <Link className="flexCenter animate pointer" to="home" smooth={true} offset={-80}>
              <img width={50} height={50} src={`${backendUrl}${data?.navimage}`} alt="Logo" />
              <h1 className="font15 extraBold whiteColor" style={{ marginLeft: "15px" }}>
                {data?.navCotent || `${name}`}
              </h1>
            </Link>
            <StyleP className="whiteColor font13">
              © {getCurrentYear()} - <span className="purpleColor font13">Kyptronix LLP</span> All Right Reserved
            </StyleP>

            <Link className="whiteColor animate pointer font13" to="home" smooth={true} offset={-80}>
              Back to top
            </Link>
          </InnerWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const InnerWrapper = styled.div`
  @media (max-width: 550px) {
    flex-direction: column;
  }
`;
const StyleP = styled.p`
  @media (max-width: 550px) {
    margin: 20px 0;
  }
`;